import React, { useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';
import Nav from "../../components/Nav";

export default function MyOrdersPage() {
  const [email, setEmail] = useState('');
  const [formState, setFormState] = useState({ error: '', message: '', pending: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormState({ ...formState, pending: true });

    try {
      // Simulating the email sending process
      await emailOrderHistory(email);
      setFormState({ ...formState, message: 'Order history sent to your email!', error: '', pending: false });

      // Reset the form after 5-6 seconds
      setTimeout(() => {
        setFormState({ ...formState, message: '', error: '', pending: false });
        setEmail('');  // Clear the email field
      }, 6000); // 6 seconds delay
    } catch (error) {
      setFormState({ ...formState, error: 'Failed to send email. Please try again.', pending: false });
    }
  };

  return (
    <div>
      <Nav />
      <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-6 p-6">
        {/* Space for image */}
        <div className="text-center">
          <img src="/images/email.jpg" alt="My Orders" width={450} height={150} className="mx-auto" />
        </div>

        {/* Card Component */}
        <div className="bg-white shadow-lg rounded-lg p-6 space-y-6">
          <div className="text-center">
            <h2 className="text-2xl font-semibold">My Orders</h2>
            <p className="text-gray-500">
              Enter your email and we will send you your order history and download links.
            </p>
          </div>
          <div className="space-y-4">
            <label htmlFor="email" className="flex items-center text-lg font-medium">
              <FaEnvelope className="mr-2 text-xl" />
              Email
            </label>
            <input
              type="email"
              required
              name="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border rounded-lg text-lg"
            />
            {formState.error && <div className="text-red-500">{formState.error}</div>}
          </div>

          {/* Card Footer */}
          <div className="mt-4 text-center">
            {formState.message ? (
              <p className="text-blue-500">{formState.message}</p>
            ) : (
              <SubmitButton pending={formState.pending} />
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

function SubmitButton({ pending }) {
  return (
    <button
      type="submit"
      disabled={pending}
      className="w-full py-3 px-4 bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white text-lg rounded-lg hover:bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white text-lg rounded-lg disabled:bg-gray-400"
    >
      {pending ? 'Sending...' : 'Send'}
    </button>
  );
}

async function emailOrderHistory(email) {
  // Replace this with your actual API call or action to email the order history.
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (email) {
        resolve();
      } else {
        reject('Invalid email');
      }
    }, 1000);
  });
}